import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MinutesOfMeeting from './minutesOfMeeting';
import {
  createMom,
  getMeetingById,
} from 'services/redux/brandActivtion/meetings/action';
import {
  imageUploadUrl,
  videoUploadUrl,
} from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
  meetingById: state.baMeetingReducer.meetingById,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { createMom, getMeetingById, imageUploadUrl, videoUploadUrl },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MinutesOfMeeting);
